import * as dhlLogoAsset from '~/assets/carriers/dhl_express.svg';
import * as fedexLogoAsset from '~/assets/carriers/fedex.svg';
import * as upsLogoAsset from '~/assets/carriers/ups.svg';
import * as uspsLogoAsset from '~/assets/carriers/usps.svg';
import * as godaddyRightContent from '~/assets/register/godaddy.png';
import * as shopifyRightContent from '~/assets/register/shopify.png';
import * as squareRightContent from '~/assets/register/square.png';
import * as wixRightContent from '~/assets/register/wix.png';
import * as ebayLogoAsset from '~/assets/shops/logos/ebay.svg';
import * as godaddyLogoAsset from '~/assets/shops/logos/godaddy.svg';
import * as shopifyLogoAsset from '~/assets/shops/logos/shopify.svg';
import * as squareLogoAsset from '~/assets/shops/logos/square.svg';
import * as wixLogoAsset from '~/assets/shops/vector/wix.svg';
import { StoreName } from '~/types/Store';

// Query param keys
export const REG_PARTNER_KEY = 'reg_partner';
export const EMAIL_KEY = 'email';

export const registerWistiaHashedId = '64znjkvorx';
export const EmbeddablesWix = 'embeddables-wix';

export interface PartnerSetting {
  logo: string;
  alt?: string;
  appUrl?: string;
  compact?: boolean;
  width?: string;
  height?: string;
  margin?: string;
  rightContent?: string;
  cobranded?: boolean;
}

const shopify: PartnerSetting = {
  logo: shopifyLogoAsset,
  alt: 'Shopify - Logo',
  appUrl: 'https://apps.shopify.com/shippo',
  margin: '2rem',
  rightContent: shopifyRightContent,
  cobranded: true,
};

const wix: PartnerSetting = {
  logo: wixLogoAsset,
  alt: 'Wix - Logo',
  appUrl: 'https://www.wix.com/app-market/shippo/overview',
  compact: true,
  rightContent: wixRightContent,
  cobranded: true,
};

const godaddy: PartnerSetting = {
  logo: godaddyLogoAsset,
  alt: 'GoDaddy - Logo',
  rightContent: godaddyRightContent,
  cobranded: false,
};

const square: PartnerSetting = {
  logo: squareLogoAsset,
  alt: 'Square - Logo',
  rightContent: squareRightContent,
  cobranded: false,
};

const weebly: PartnerSetting = {
  logo: squareLogoAsset,
  alt: 'Square - Logo',
  rightContent: squareRightContent,
  cobranded: false,
};

const ebay: PartnerSetting = {
  logo: ebayLogoAsset,
  alt: 'eBay - Logo',
  compact: true,
  cobranded: true,
};

const usps: PartnerSetting = {
  logo: uspsLogoAsset,
  alt: 'USPS - Logo',
  compact: false,
  width: '9rem',
  cobranded: true,
};

const fedex: PartnerSetting = {
  logo: fedexLogoAsset,
  alt: 'FedEx - Logo',
  compact: false,
  width: '7rem',
  cobranded: true,
};

const ups: PartnerSetting = {
  logo: upsLogoAsset,
  alt: 'UPS - Logo',
  compact: false,
  width: '5rem',
  height: '5rem',
  cobranded: true,
};

const dhl_express: PartnerSetting = {
  logo: dhlLogoAsset,
  alt: 'DHL Express - Logo',
  compact: false,
  width: '5rem',
  margin: '2.188rem',
  cobranded: true,
};

export const partnerSettings: { [partnerName: string]: PartnerSetting } = {
  [StoreName.Shopify.toLowerCase()]: shopify,
  [StoreName.Wix.toLowerCase()]: wix,
  [EmbeddablesWix]: wix,
  [StoreName.eBay.toLowerCase()]: ebay,
  [StoreName.Godaddy.toLowerCase()]: godaddy,
  [StoreName.Square.toLowerCase()]: square,
  [StoreName.Weebly.toLowerCase()]: weebly,
  usps,
  fedex,
  ups,
  dhl_express,
};

export const referralStores: string[] = [
  StoreName.Shopify.toLowerCase(),
  StoreName.Wix.toLowerCase(),
  StoreName.Godaddy.toLowerCase(),
  StoreName.Square.toLowerCase(),
  StoreName.Weebly.toLowerCase(),
  EmbeddablesWix,
];
